import { accountSearchColumns, phiSearchColumns, QUERY_KEYS } from '@/constants';
import { FormField, SearchField } from '@/components/custom/erp';
import { AccountModel, Phi } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

interface BasicFormProps {
  formMode: FormMode;
  assetAccount: AccountModel | null;
  setAssetAccount: (account: AccountModel) => void;
  depreciationAccount: AccountModel | null;
  setDepreciationAccount: (account: AccountModel) => void;
  expenseAccount: AccountModel | null;
  setExpenseAccount: (account: AccountModel) => void;
  fee: Phi | null;
  setFee: (fee: Phi) => void;
}

const BasicForm: React.FC<BasicFormProps> = ({
  formMode,
  assetAccount,
  setAssetAccount,
  depreciationAccount,
  setDepreciationAccount,
  expenseAccount,
  setExpenseAccount,
  fee,
  setFee
}) => {
  const isViewMode = formMode === 'view';

  return (
    <div className='max-h-[calc(100vh-150px)] space-y-3 overflow-y-auto p-4'>
      {/* Tài sản/Công cụ */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Tài sản/Công cụ</Label>
        <FormField
          type='select'
          name='loai_tscc'
          className='w-full'
          disabled={isViewMode}
          options={[
            { value: '1', label: '1. Tài sản' },
            { value: '2', label: '2. Công cụ' }
          ]}
        />
      </div>

      {/* Mã loại */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Mã loại</Label>
        <FormField type='text' name='ma_lts' className='w-full' disabled={formMode === 'view' || formMode === 'edit'} />
      </div>

      {/* Tên loại */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Tên loại</Label>
        <FormField type='text' name='ten_lts' className='w-full' disabled={isViewMode} />
      </div>

      {/* Tên khác */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Tên khác</Label>
        <FormField type='text' name='ten_lts2' disabled={isViewMode} />
      </div>

      {/* Tài khoản */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Tài khoản</Label>
        <SearchField<AccountModel>
          type='text'
          displayRelatedField={'name'}
          columnDisplay={'code'}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={accountSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={assetAccount?.code || ''}
          relatedFieldValue={assetAccount?.name || ''}
          onRowSelection={setAssetAccount}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      {/* Tk khấu hao */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Tk khấu hao</Label>
        <SearchField<AccountModel>
          type='text'
          displayRelatedField={'name'}
          columnDisplay={'code'}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={accountSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={depreciationAccount?.code || ''}
          relatedFieldValue={depreciationAccount?.name || ''}
          onRowSelection={setDepreciationAccount}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      {/* Tk chi phí */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Tk chi phí</Label>
        <SearchField<AccountModel>
          type='text'
          displayRelatedField={'name'}
          columnDisplay={'code'}
          searchEndpoint={`/${QUERY_KEYS.TAI_KHOAN}`}
          searchColumns={accountSearchColumns}
          dialogTitle='Danh mục tài khoản'
          value={expenseAccount?.code || ''}
          relatedFieldValue={expenseAccount?.name || ''}
          onRowSelection={setExpenseAccount}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      {/* Mã phí */}
      <div className='flex items-center'>
        <Label className='min-w-40'>Mã phí</Label>
        <SearchField<Phi>
          type='text'
          displayRelatedField={'ten_phi'}
          columnDisplay={'ma_phi'}
          searchEndpoint={`/${QUERY_KEYS.PHI}`}
          searchColumns={phiSearchColumns}
          dialogTitle='Danh mục phí'
          value={fee?.ma_phi || ''}
          relatedFieldValue={fee?.ten_phi || ''}
          onRowSelection={setFee}
          disabled={isViewMode}
          className='w-100'
        />
      </div>

      {/* Trạng thái */}
      <div className='flex items-center'>
        <Label htmlFor='status' className='min-w-40'>
          Trạng thái
        </Label>
        <FormField
          id='status'
          type='select'
          name='status'
          className='w-full'
          disabled={isViewMode}
          options={[
            { value: '1', label: '1. Còn sử dụng' },
            { value: '0', label: '0. Không sử dụng' }
          ]}
        />
      </div>
    </div>
  );
};

export default BasicForm;
